module.exports = __webpack_public_path__ + "static/media/4 Train-AP_Z1.fad61ded.png";